import LandingPage from "./components/LandingPage";
import AboutUs from "./components/AboutUs";
import ContactUs from "./components/ContactUs";
import NotFound from "./components/NotFound";
import Testimonials from './components/Testimonials'
import Projects from './components/Project'
import Consultancy from './components/Consultancy'

export const routes = [
    {path: '/', name: 'home', component: LandingPage},
    {path: '/about-us', name: 'aboutus', component: AboutUs},
    {path: '/contact-us', component: ContactUs},
    {path: '/testimonials', component: Testimonials},
    {path: '/projects', component: Projects},
    {path: '/consultancy', component: Consultancy},
    {path: '/*', component: NotFound},
]